/**
 * Общий layout с плашкой и хлебными крошками (02_GPT-MODULAR).
 * Не размонтируется при смене маршрута — реверс-анимация работает.
 */

import { useEffect } from "react";
import { useLocation, Outlet } from "react-router-dom";
import { getPageTitle, getPageLabelGreen, getPageTextBelowPlank } from "../../config/breadcrumbRoutes";
import BreadcrumbAnimated from "../BreadcrumbAnimated/BreadcrumbAnimated";
import "./LayoutWithPlank.css";

function LayoutWithPlank() {
    const location = useLocation();
    const pathname = location.pathname;
    const title = getPageTitle(pathname);
    const labelGreen = getPageLabelGreen(pathname);
    const textBelowPlank = getPageTextBelowPlank(pathname);

    // Reset scroll on route change (но /contact -> form обрабатывает ContactPage)
    useEffect(() => {
        if (pathname === "/contact" && location.state?.scrollToForm) return;
        window.scrollTo(0, 0);
    }, [pathname, location.state]);

    return (
        <div className="group-6-wrap">
            <section className="group-6">
                <div className="group-6__header">
                    <span className="group-6__header-bracket">[</span>
                    <span className="group-6__header-label">route</span>
                    <span className="group-6__header-bracket">]</span>
                </div>
                <div className="group-6__code">
                    <div className="group-6__line">
                        <span className="group-6__line-num">1</span>
                        <h1 className="group-6__title"><span className="group-6__prompt">&gt;</span> {title}</h1>
                    </div>
                    <div className="group-6__line">
                        <span className="group-6__line-num">2</span>
                        <BreadcrumbAnimated speed={70} delay={300} />
                    </div>
                </div>
            </section>
            {(labelGreen || textBelowPlank) && (
                <div className="group-7">
                    {labelGreen && (
                        <p className={`group-7__label${pathname === "/program" ? " group-7__label_program" : ""}`}>{labelGreen}</p>
                    )}
                    {textBelowPlank && (() => {
                        const parts = textBelowPlank.split("Business");
                        return (
                            <p className="group-7__mission">
                                {parts.length > 1 ? (
                                    <> {parts[0]}<span className="group-7__highlight">Business</span>{parts[1]} </>
                                ) : (
                                    textBelowPlank
                                )}
                            </p>
                        );
                    })()}
                </div>
            )}
            <Outlet />
        </div>
    );
}

export default LayoutWithPlank;
// components/LayoutWithPlank/LayoutWithPlank.js
